import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'modules/_shared/components/Buttons';
import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';
import TestEmailPanel from './TestEmailPanel';

const NotifyPartnersDividendsModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useNotifyPartnersDividendsModal();

  const buttonEnabled =
    data?.partnersData?.length > 0 &&
    !data?.hasInvalidEmails &&
    !data?.showTestEmailPanel;

  return (
    <>
      <TestEmailPanel />

      <Modal.Footer className="flex-column p-0">
        <div className="d-flex justify-content-between w-100 p-3">
          <Button
            onClick={actions.handleToggleTestEmailPanel}
            lgSize
            outlineStyle
          >
            {data.showTestEmailPanel ? t('HideTestPanel') : t('SendTestEmail')}
          </Button>
          <Button
            onClick={actions.handleSendEmails}
            lgSize
            disabled={!buttonEnabled}
          >
            {t('SendNotification')}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default NotifyPartnersDividendsModalFooter;
